<template>
  <div class="home"  :class="{ 'darkmode': darkMode, }">
    <div class="sidenav">
       <div class="user g_clearfix_before">
        <div class="user-avatar">
          <img class="avatar" :src="user && user.avatarProxy" alt='avatar' />
        </div>
        <div class="user-info">
          <div class="user-name">
            <span class="text">{{user && user.nickname}}</span>
            <span @click="toggleUserPop" role='button' :aria-label="$t('index.nav.btnAriaLabel')"   class="icon" :class="{'btn_active': showUserPop}" tabIndex="-1">
              <i class="icon-angle-down"></i>
              <ul class="user-pop g_pop"  :class="{'g_pop_active': showUserPop}"  role='menubar'>
                <router-link class="item" :to="{ name: 'profile'}" >{{$t('index.nav.account')}}</router-link >
                <li class="item" @click="showSetting">{{$t('index.nav.settings')}}</li>
                <router-link class="item" :to="{ name: 'feedback'}" >{{$t('index.nav.feedback')}}</router-link >
                <li class="item" @click="toggleAboutPanel">{{$t('index.nav.about')}}</li>
                <li class="item">
                  <Btn
                    class="logoutbtn"
                    :label="$t('index.nav.signOut')"
                    @click.native.stop="loginOut"
                    :loading="logOuting"
                  ></Btn>
                </li>
              </ul>
            </span>
            <p class="user-email">{{user && user.email}}</p>
          </div>
          <Btn
            type="progress"
            :updating="updating"
            :progress="updatingProgress"
            @click.native="updateStars"
            class="updatebtn"
            :title="$t('index.updateBtn')"
            :class="{'icon-refresh': !updating, 'updatebtn_loading': updating}"
          />
        </div>
      </div>
      <header class="taglistheader">
        <!-- <span @click="toggleTagToolbar" class="add icon-add" role="button" aria-label="添加分类" tabIndex="0"></span> -->
        <div class="taglistheader-t">
          <div class="header-title">
            <ul class="header-titlelist" :class="{'header-titlelist_recommend': listType === 'recommend', 'header-titlelist_my': listType === 'my', 'header-titlelist_git': listType === 'git'}">
              <li class="item">{{$t('index.list.overview')}}</li>
              <li class="item">{{$t('index.list.explore')}}</li>
              <li class="item">{{$t('index.list.myCollections')}}</li>
              <li class="item">{{$t('index.list.githubCollections')}}</li>
            </ul>
          </div>
          <div class="icon-search search-btn" @click="toogleSearch"></div>
          <Sort :sortBy="tagSortBy"
          :changeSortBy="changeTagSortBy"
          class="sort" />
        </div>
      </header>
      <List
        ref="list"
        @hideSearch="showSearch = false"
        :showSearch="showSearch"
        :toggleStarPanel="toggleStarPanel"
        @changeHeaderTitle="changeHeaderTitle"
        @toggleAddTagToolbar="toggleTagToolbar"
        class="taglistwrapper"
        :tagSortBy="tagSortBy"/>
      <TagToolBar :delTagCallback="toggleStarPanel" :showTagToolBar="showTagToolBar" :toggleTagToolbar="toggleTagToolbar"/>
    </div>
    <div class="content">
      <router-view :tag="chooseTag" ref="con"/>
    </div>
    <IconPenal/>
    <StarEditPanel @refresh="starEditRefresh"/>
    <Upgrade/>
    <AccessTokenDialog/>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Btn from '@/components/Btn'
import Sort from '@/components/Sort'
// import Loading from '@/components/Loading'
import List from '@/components/List'
import TagToolBar from '@/components/TagToolBar'
import Upgrade from '@/components/Upgrade'
import AccessTokenDialog from '@/components/AccessTokenDialog'
import IconPenal from './Icon'
import StarEditPanel from './StarEditPanel'
import { updateContentPage } from '@/util/chrome.api'

// @ is an alias to /src
export default {
  name: 'home',
  components: {
    Btn,
    List,
    Sort,
    TagToolBar,
    IconPenal,
    StarEditPanel,
    Upgrade,
    AccessTokenDialog,
  },
  data() {
    return {
      showAboutPanel: false,
      showStarsPanel: false,
      updating: false,
      showUserPop: false,
      logOuting: false,
      showTagToolBar: false,
      listType: '',
      tagSortBy: 'time',
      showStarPanel: false,
      chooseTag: null,
      loading: false,
      updatingText: this.$t('index.list.loadingText'),
      scrollTop: 10,
      animateTimer: null,
      animateClearTimer: null,
      showSearch: false,
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.user,
      tags: state => state.star.tags,
      stars: state => state.star.stars,
      isUpdating: state => state.star.isUpdating,
      updatingProgress: state => state.star.updateTagProgress,
      updatedTimeStamp: state => state.star.updatedTimeStamp,
      onEventPanel: state => state.event.onEventPanel,
      showAddBarHotkey: state => state.event.showAddBar,
      searchTagHotKey: state => state.event.searchTag,
    }),
  },
  watch: {
    showAddBarHotkey(newVal, oldVal) {
      console.log(oldVal)
      this.$hotkeys.unbind(oldVal)
      this.initHotKey()
    },
    searchTagHotKey(newVal, oldVal) {
      this.$hotkeys.unbind(oldVal)
      this.initHotKey()
    },
  },
  mounted() {
    this.init()
    this.initHotKey()
    this.updateUserInfo()
    // .catch(() => {
    //   this.$router.push({
    //     name: 'login',
    //   })
    // })
  },
  beforeDestroy() {
    this.unBindHotKey()
  },
  methods: {
    ...mapActions({
      updateUserInfo: 'user/updateUserInfo',
      logOut: 'user/logOut',
      getTags: 'star/getTags',
      initDatas: 'star/initDatas',
      updateTags: 'star/updateTags',
      getStars: 'star/getStars',
      getUserInfo: 'user/getUserInfo',
      initSettingState: 'initSettingState',
    }),
    initHotKey() {
      this.$hotkeys(this.showAddBarHotkey, (e) => {
        e.preventDefault()
        if (this.onEventPanel !== 'hotKeyEdit') { this.toggleTagToolbar() }
        return false
      })
      this.$hotkeys(this.searchTagHotKey, (e) => {
        e.preventDefault()
        this.showSearch = !this.showSearch
        console.log('command+shift+l')
        return false
      })
    },
    unBindHotKey() {
      this.$hotkeys.unbind(this.showAddBarHotkey)
      this.$hotkeys.unbind(this.searchTagHotKey)
    },
    async init() {
      this.loading = true

      // 初始化设置数据
      this.initSettingState()

      // 初始化star和tag数据
      await this.initDatas()
      if (!this.stars || !Object.keys(this.stars).length) {
        this.getStars()
      }

      this.getTags().then((res) => {
        if (!res.tags || res.tags.length === 0 ||
            !this.stars || Object.keys(this.stars).length === 0 ||
            (new Date().getTime() - 24 * 60 * 60 * 1000) > this.updatedTimeStamp) {
          this.updateStars()
          this.loading = false
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    toogleSearch() {
      this.showSearch = !this.showSearch
    },
    starEditRefresh() {
      this.$refs.con.$emit('refresh')
    },
    updateStars() {
      if (this.updating) return
      this.updating = true
      this.updateTags({ update: true }).then((data) => {
        this.$forceUpdate()
        this.updating = false
        this.loading = false
        this.$toast({
          msg: this.$i18n.t('index.finishUpdate'),
        })
      }).catch((err) => {
        this.updating = false
        if (err && err.status === 401) {
          this.loginOut()
          return
        }

        this.$toast({
          msg: err && err.msg ? err.msg : this.$i18n.t('index.updateErr'),
        })
      })
    },
    /**
     * 筛选list
     */
    changeTagSortBy(val) {
      this.tagSortBy = val
    },
    /**
     * 添加和编辑toolbar
     */
    toggleTagToolbar() {
      this.showTagToolBar = !this.showTagToolBar
    },
    /**
     * 显示starsPanel
     */
    toggleStarPanel(tag) {
      this.chooseTag = tag
      console.log('toggleStarPanel', tag)
      this.$router.push({
        name: 'repos',
        query: {
          ...this.$route.query,
          id: tag._id,
        },
      })
    },
    toggleUserPop(e) {
      this.showUserPop = !this.showUserPop
      if (this.showUserPop) {
        setTimeout(() => {
          document.addEventListener('click', this.toggleUserPop, false)
        }, 0)
      } else {
        document.removeEventListener('click', this.toggleUserPop)
      }
    },
    showSetting() {
      this.$router.push({
        name: 'setting',
      })
    },
    /**
     * about界面
     */
    toggleAboutPanel() {
      this.$router.push({
        name: 'about',
      })
    },
    changeHeaderTitle(val) {
      this.listType = val
    },
    loginOut() {
      this.$toast({
        isConfirm: true,
        msg: this.$t('index.signOutConfirm'),
      }).then(() => {
        this.logOuting = true

        this.logOut().then(() => {
          this.logOuting = false
          // 通知content page更新登陆状态
          updateContentPage({ login: false })
          this.$router.push({
            name: 'login',
          })
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.home{
  display: flex;
  align-content: stretch;
  height: 100%;
}
.sidenav{
  width: 250px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  border-right: 1px solid rgba(195,195,195,0.50);
  position: relative;
  background: #f9f9f9;
  //用户信息
  //**************
  .user {
    height: 152px;
    // background-image: linear-gradient(-180deg, rgba(251,251,251,0.09) 0%, #F1F1F1 100%);
    background-image: linear-gradient(-180deg,rgba(255,255,255, 0.9),#eaeaea);
    // box-shadow: 0 0.5px 0 0 rgba(194,194,194,0.50);
    box-shadow: 0 0.5px 0 0 rgba(194,194,194, 1);
    // border-radius: 4px 4px 0 0;
    position: relative;
    flex-shrink: 0;
  }
  .user-avatar {
    width: 86px;
    height: 86px;
    border-radius: 999px;
    overflow: hidden;
    background: #EBEBEB;
    margin: 12px auto 8px;
  }
  .avatar {
    width: 100%;
    height: 100%;
    border-radius: 999px;
  }
  .user-info {
    text-align: center;
  }
  .user-name,
  .user-email {
    padding: 0 16px;
  }
  .user-email{
    font-size: 12px;
    color: #A6A6A6;
    line-height: 14px;
    font-weight: normal;
    text-align: center;
  }
  .user-name{
    font-weight: bold;
    font-size: 20px;
    color: #484848;
    line-height: 22px;
    text-align: center;
  }
  .user-name .icon{
    position: relative;
    margin-left: 1px;
    display: inline-block;
  }
  .user-name .icon-angle-down{
    position: relative;
    font-size:12px;
    color:#A6A6A6;
    height: 12px;
    line-height: 1em;
    border-radius: 2px;
    display: inline-block;
    margin-left: 1px;
    padding: 0 2px;
    cursor: pointer;
    &:hover{
      background: #E3E3E3;
    }
  }
  .user-name .btn_active .icon-angle-down{
    background: #E3E3E3;
  }

  .updatebtn{
    position: absolute;
    right:10px;
    top:10px;
    background-image: linear-gradient(-180deg, rgba(235,235,235,0.56) 0%, #EBEBEB 100%);
    border-radius: 2px;
    color: #7B7B7B;
    font-size: 14px;
    width: 22px;
    height: 22px;
    overflow: hidden;
    text-align: center;
    line-height: 22px;
    cursor: pointer;
    span{
      display: none;
    }
    &:hover{
      background-image: linear-gradient(-180deg, rgba(218,218,218,0.59) 0%, #D9D9D9 100%);
    }
  }

  .updatebtn_loading{
    cursor: not-allowed;
    /* Rectangle 2: */
    background: linear-gradient(-180deg, rgba(235,235,235,0.56) 0%, #EBEBEB 100%);
    &:hover{
      background: linear-gradient(-180deg, rgba(235,235,235,0.56) 0%, #EBEBEB 100%);
    }
  }
  .logoutbtn{
    background: none;
    width: 100%;
    height: 26px;
    line-height: 26px;
    font-size: 12px;
    color: #444;
    cursor: pointer;
    font-weight: 400;
    border-radius: none;
    &:hover{
      background: none;
      color: #fff;
    }
  }
}

.taglistheader{
  // height: 20px;
  padding:24px 10px 6px;
  .header-title{
    line-height:20px;
    height: 20px;
    font-size: 14px;
    width: 170px;
    color: #494949;
    float: left;
    position: relative;
    overflow: hidden;
    flex: 1;
  }
  .header-titlelist{
    transition: all 0.3s ease;
    position: absolute;
    transform: translateZ(0);
    top:0;
    .item{
      height: 18px;
    }
  }
  .header-titlelist_recommend{
    transform: translate3d(0, -18px, 0);
  }
  .header-titlelist_my{
    transform: translate3d(0, -36px, 0);
  }
  .header-titlelist_git{
    transform: translate3d(0, -54px, 0);
  }
  .add,
  .search-btn,
  .sort{
    width: 22px;
    height: 16px;
    margin-top: 2px;
    color: #7B7B7B;
    text-align: center;
    line-height: 16px;
    float: right;
    font-size:12px;
    background: #EBEBEB;
    border-radius: 2px;
    margin-left:5px;
    cursor: pointer;
    &:hover{
      background: #D9D9D9;
    }
  }
  .sort{
    position: relative;
  }
}
.taglistheader-t{
  display: flex;
}
.taglistwrapper{
  flex: 1 1 auto;
}

.content{
  flex: 1 1 auto;
}

/** darkmode **/
.darkmode{
  background: #292929;
  .sidenav{
    border-right: 1px solid #414141;
    background: #292929;
  }
  .user {
    // background-image: linear-gradient(180deg, #464543 5%, #3C3B39 99%);
    background-image: linear-gradient(180deg,#464543 5%,#343432 99%);
    box-shadow: 0 0.5px 0 0 rgba(32,32,32,0.50);
    background-image: linear-gradient(180deg, #464543 5%, #3C3B39 99%);
  }
  .user-email{
    color: #AEAEAE;
  }
  .user-name{
    color: #FFFFFF;
  }

  .logoutbtn{
    color: #fff;
  }
  .taglistheader{
    background: #292929;
    box-shadow: 0 -0.5px 0 0 rgba(18, 18, 18, 0.5);
    .header-title{
      color: #FFFFFF;
    }
    .add,
    .search-btn,
    .sort{
      color: #FFFFFF;
      background: #5D5D5D;
      &:hover{
        background: #8E8E8E;
      }
    }
  }
  .updatebtn{
    background: #5D5D5D;
    box-shadow: 0 0 2px 0 rgba(42,42,42,0.20);
    border-radius: 2px;
    font-family: simple-line-icons;
    font-size: 14px;
    color: #FFFFFF;
    &:hover{
      background: #5D5D5D;
    }
  }
  .updatebtn_loading .icon-refresh:before{
    color: #FFFFFF;
  }
  .taglistwrapper{
    background-color: #292929; // #323232;
  }
}
</style>
